import {
	Footer as DsFooter,
	FooterLinkGroup,
	FooterSection,
	FooterSectionGroup,
	LegalLinks,
	SocialLinks,
	TrackingLink,
} from '@ds-mgnl/marketing';
import { Image, Link, Text } from '@dsx/react';
import footerLogo from '../../assets/images/dssi-logo.svg';
import styles from './Footer.module.css';

export const Footer = () => {
	const currentYear = new Date().getFullYear();
	const copyright = `©2009-${currentYear} Direct Supply, Inc. All rights reserved.`;

	return (
		<div className={styles['footer-container']}>
			<DsFooter
				header={
					<TrackingLink
						href="/"
						clickType="footer_link"
						trackingText="Footer Logo"
					>
						<Image
							src={footerLogo}
							alt="DSSI Logo"
							className={styles['footerLogo']}
							loading="lazy"
						/>
					</TrackingLink>
				}
				subFooter={
					<LegalLinks
						links={[
							{
								children: 'Application Privacy & Legal Information',
								href: '/legal/application-privacy',
							},
							{
								children: 'Terms of Use',
								href: '/legal/terms-of-use',
							},
							{
								children: 'Privacy Policy',
								href: '/legal/privacy-policy',
							},
							{
								children: 'Cookie Policy',
								href: '/legal/cookie-policy',
							},
							{
								children: 'California Collection Notice',
								href: '/legal/privacy-policy#california-collection-notice',
							},
						]}
						copyrightText={copyright}
					/>
				}
			>
				<FooterSectionGroup key="contact-social">
					<FooterSection title="Contact us" columnCount={1} columnWidth="200px">
						<div>
							<Text variant="body-small">Need help or have a question?</Text>
							<Link
								href="/contact"
								size="small"
								linkStyle="standalone"
								actionIndicator="MdArrowForward"
							>
								Contact us
							</Link>
						</div>
					</FooterSection>
					<SocialLinks
						links={[
							{
								href: 'https://www.facebook.com/directsupply',
								site: 'facebook',
							},
							{
								href: 'https://twitter.com/_DirectSupply',
								site: 'twitterX',
							},
							{
								href: 'http://www.linkedin.com/company/direct-supply',
								site: 'linkedin',
							},
							{
								href: 'http://www.youtube.com/c/directsupply',
								site: 'youtube',
							},
						]}
					/>
				</FooterSectionGroup>

				<FooterSection
					key="dssi"
					title="DSSI"
					columnCount={3}
					columnWidth="200px"
				>
					<FooterLinkGroup
						title="Procure to Pay"
						links={[
							{
								href: '/solutions/procure-to-pay/ap-automation',
								children: 'AP Automation',
							},
							{
								href: '/solutions/procure-to-pay/inventory-management',
								children: 'Inventory Management',
							},
							{
								href: '/solutions/procure-to-pay/supply-chain-management',
								children: 'Supply Chain Management',
							},
							{
								href: 'https://www.directs.com/dssi/default.aspx',
								children: 'Sign In',
								target: '_blank',
							},
						]}
					/>

					<FooterLinkGroup
						title="Spend Optimization"
						links={[
							{
								href: '/solutions/spend-optimization/supply-chain-consulting',
								children: 'Supply Chain Consulting',
							},
							{
								href: '/solutions/spend-optimization/ai-in-procurement',
								children: 'AI in Procurement',
							},
							{
								href: '/solutions/spend-optimization/food-procurement',
								children: 'Food Procurement',
							},
						]}
					/>

					<FooterLinkGroup
						title="Resources"
						links={[
							{ href: '/resources/blogs', children: 'Expertise' },
							{ href: '/resources/case-studies', children: 'Success Stories' },
						]}
					/>
				</FooterSection>
			</DsFooter>
		</div>
	);
};
